import React from "react";
import { tokenPacks } from "../utils/constant";
import { Row, Col, Card, Button } from "react-bootstrap";

export const TokenPacksSection = ({ onAddToCart }) => {
  return (
    <section className="py-5 px-3 bg-[#F3F1EF]">
      <h2 className="text-center text-4xl fw-bold mb-5" style={{ color: "#2959A5" }}>
        Choose Your Token Pack
      </h2>
      <Row className="justify-content-center">
        {tokenPacks.map((pack) => (
          <Col key={pack.name} xs={12} md={6} lg={4} className="mb-4 d-flex">
            <Card className="flex-fill shadow border-2 border-light rounded-4" style={{ background: "#FFFFFF" }}>
              <Card.Body className="d-flex flex-column justify-content-between">
                <div>
                  <Card.Title className="text-center" style={{ color: "#2959A5", fontWeight: "700", fontSize: "1.5rem" }}>
                    {pack.name}
                  </Card.Title>
                  <Card.Subtitle className="mb-2 text-muted text-center">{pack.tokens} Tokens</Card.Subtitle>
                  <h3 className="text-center fw-bold mb-3" style={{ color: "#EF3E6D", fontSize: "2rem" }}>
                    ${pack.price}
                  </h3>
                  <Card.Text className="text-center text-muted mb-4">
                    Perfect for different scales of event scheduling and promotion.
                  </Card.Text>
                </div>
                <Button
                  variant="danger"
                  className="rounded-pill fw-semibold py-2"
                  style={{ backgroundColor: "#EF3E6D", borderColor: "#EF3E6D" }}
                  onClick={() => onAddToCart(pack)}
                >
                  Add to Cart
                </Button>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </section>
  );
};
